var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilterDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-StandardActivities",
    transform: "translate(-331.000000, -162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(261.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-filter",
    transform: "translate(70.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    fill: "#646464",
    points: "0 6.25 6.25 6.25 3.125 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-23",
    fill: "#EAEAEA",
    transform: "translate(3.125000, 1.875000) rotate(-180.000000) translate(-3.125000, -1.875000) ",
    points: "0 0 6.25 0 3.125 3.75"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterDown);
export default __webpack_public_path__ + "static/media/ic-filter-down.24f1de961735f9cbb8539df2e0675020.svg";
export { ForwardRef as ReactComponent };